// action types
export const ACTION_TYPE_PAGE_VIEW = 12;

export const ACTION_TYPE_HELPER_ENTRY_BOX = 13;
export const ACTION_TYPE_HELPER_LAUNCH = 14;
export const ACTION_TYPE_HELPER_BRAND_SELECT = 15;

export const ACTION_TYPE_DASHBOARD_CSV_EXPORT = 16;
export const ACTION_TYPE_DASHBOARD_PNG_EXPORT = 17;
export const ACTION_TYPE_DASHBOARD_BRAND_SELECT = 18;
export const ACTION_TYPE_DASHBOARD_DATE_SELECT = 19;
export const ACTION_TYPE_DASHBOARD_FILTER_REDIRECT = 20;

export const ACTION_TYPE_SEARCH_CSV_EXPORT = 21;
export const ACTION_TYPE_SEARCH_FILTER_SELECT = 22;

export const ACTION_TYPE_APP_LOAD = 25;

export const ACTION_TYPE_CLUSTER_VIEW = 27;
export const ACTION_TYPE_CLUSTER_OPEN = 28;
export const ACTION_TYPE_SUBCLUSTER_OPEN = 29;

export const ACTION_TYPE_TOPICS_VIEW = 30;
export const ACTION_TYPE_TOPIC_CREATE = 31;
export const ACTION_TYPE_TOPIC_EDIT = 32;
export const ACTION_TYPE_TOPIC_DELETE = 33;
export const ACTION_TYPE_TOPICS_EXPORT = 34;

export const ACTION_TYPE_HELPER_QUESTION_ASKED = 36;
export const ACTION_TYPE_HELPER_ANSWER_RETURNED = 37;

// event types
export const EVENT_TYPE_AUTO = 0
export const EVENT_TYPE_CLICK = 1

// action module
export const ACTION_MODULE_NEW_UI_NAVIGATION_CHANGE = 'NewUI.NavigationChange'
export const ACTION_MODULE_NEW_UI_HELPER = 'NewUI.Helper'
export const ACTION_MODULE_NEW_UI_DASHBOARD = 'NewUI.Dashboard'
export const ACTION_MODULE_NEW_UI_SEARCH = 'NewUI.Search'
export const ACTION_MODULE_NEW_UI_TOPICS = 'NewUI.Topics'
export const ACTION_MODULE_NEW_UI_CLUSTERS = 'NewUI.Clusters'

// context types
export const CONTEXT_TYPE_FILTER = 'filter'